import { render, staticRenderFns } from "./OBtnOptionToolTipComp.vue?vue&type=template&id=44aeba95&"
import script from "./OBtnOptionToolTipComp.vue?vue&type=script&lang=js&"
export * from "./OBtnOptionToolTipComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports